<div *ngIf='sessionData && loading == false' class='ViewMessage'>
  <h4 class='title__page'>Edit meeting</h4>
  <div *ngIf='formReady' class='details'>
    <form [formGroup]='formGroup'>
      <div class='row'>
        <div class='col col-12 col-sm-4'>Name:</div>
        <div class='col col-12 col-sm-4'>
          <app-text-field
            [iconProps]='editRepIconProp'
            formControlName='name'
            placeholder='Name'></app-text-field>
        </div>
        <div class='col col-12 col-sm-4'></div>
      </div>
      <div class='row'>
        <div class='col col-12 col-sm-4'>Company:</div>
        <div class='col col-12 col-sm-4'>
          <app-text-field
            formControlName='company'
            placeholder='Company'></app-text-field>
        </div>
      </div>
      <div class='row'>
        <div class='col col-12 col-sm-4'>Primary email:</div>
        <div class='col col-12 col-sm-4'>
          <app-text-field
            formControlName='phone'
            placeholder='Phone'></app-text-field>
        </div>
      </div>
      <div class='row'>
        <div class='col col-12 col-sm-4'>Meeting date:</div>
        <div class='col col-12 col-sm-4'>
          <app-text-field
            datePickerType='calendar'
            formControlName='meeting_date'
            placeholder='Meeting date'
            type='date'></app-text-field>
        </div>
      </div>
      <div class='row'>
        <div class='col col-12 col-sm-4'>Meeting time:</div>
        <div class='col col-12 col-sm-4'>
          <mat-form-field>
            <input
              [format]='24'
              [ngxTimepicker]='timepicker'
              formControlName='meeting_time'
              matInput />
            <ngx-material-timepicker
              #timepicker
              [appendToInput]='true'
              [defaultTime]='formGroup.controls.meeting_time'></ngx-material-timepicker>
          </mat-form-field>
        </div>
      </div>
      <div class='row'>
        <div class='col col-12 col-sm-4'>Notes:</div>
        <div class='col col-12 col-sm-4'>
          <mat-form-field class='w-100'>
            <textarea formControlName='meeting_note' matInput></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class='row controls'>
        <div class='col-6'>
          <app-button
            (click)='back()'
            [color]="'red'"
            [size]="'normal'"
            [text]="'Back'"></app-button>
        </div>
        <div class='col-6 text-right'>
          <app-button
            (click)='submit()'
            [color]="'blue'"
            [size]="'normal'"
            [text]="'Save'"></app-button>
        </div>
      </div>
    </form>
  </div>
</div>
